module.exports = __webpack_public_path__ + "static/media/diversity.5cf69064.svg";